'use client';

import { useLayoutEffect } from 'react';
import { subscribeDatadogConsent } from '@/lib/datadog/consent';

export function DatadogConsentSync() {
    useLayoutEffect(subscribeDatadogConsent, []);

    return null;
}
